import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import { withProps, compose, withHandlers } from 'recompose';
import Form from './components/Form';
import { syncValidateData } from '../../../common/validator';
import { PROMO_TYPE } from './constants';
import { isPercentagePromo } from './selectors';
import servicesProvider from '../../services/hoc/servicesProvider';
import { getActiveBrandId } from '../../../auth/selectors';
import brandPromoModal from './containers/BrandPromoModal';
import productsProvider from '../../../products/products/hoc/productsProvider';
import withProducts from '../../../products/products/hoc/withProducts';

const PROMO_FORM = 'promoForm';

const schema = Joi.object().keys({
  id: Joi.string().guid().optional(),
  code: Joi.string().min(3).required(),
  kind: Joi.number().optional().valid(Object.values(PROMO_TYPE)).default(PROMO_TYPE.amount),
  value: Joi.when('kind', {
    is: PROMO_TYPE.amount,
    then: Joi.number().min(0).required(),
    otherwise: Joi.number().min(0).max(100).required(),
  }),
  firstAppointmentOnly: Joi.boolean(),
  oneTime: Joi.boolean(),
});

const validate = values => syncValidateData(values, schema);
const formSelector = formValueSelector(PROMO_FORM);

export const form = compose(
  brandPromoModal,
  servicesProvider,
  productsProvider,
  withProducts,
  connect(state => ({
    isPercentage: isPercentagePromo({ kind: formSelector(state, 'kind') }),
    isScheduled: formSelector(state, 'isScheduled'),
    isForServicesOrProducts: formSelector(state, 'isForServicesOrProducts'),
    shops: formSelector(state, 'shops'),
    isBrandPromo: formSelector(state, 'isBrandPromo'),
    activeBrandId: getActiveBrandId(state),
    usableEveryNumberOfDays: formSelector(state, 'usableEveryNumberOfDays'),
    isUsableEveryNumberOfDays: formSelector(state, 'isUsableEveryNumberOfDays'),
    isUsableNumberOfTimes: formSelector(state, 'isUsableNumberOfTimes'),
  })),
  reduxForm({
    form: PROMO_FORM,
    onSubmitSuccess: (_values, _dispatch, props) => {
      if (props.baseUrl) props.router.push(props.baseUrl);
    },
    validate,
  }),
  withHandlers({
    onKindChange: props => () => props.change('value', ''),
  }),
  withProps(props => ({
    isEditingDisabled: props.isBrandPromo && !props.activeBrandId,
  }))
);

export default compose(
  withRouter,
  form
)(Form);
